import FloatingPC from '@/rebuild/materials/shared/floating/BaseFloatingPC.vue';
import FloatingMobile from '@/rebuild/materials/shared/floating/BaseFloatingMobile.vue';

export const componentMap = {
	basic: FloatingPC,
	'basic-mobile': FloatingMobile
};
